module.exports = __webpack_public_path__ + "img/icon-search.99f761f345fa916415745745f7147a3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/core/gfx/icon-search.png
// module id = 106
// module chunks = 1